import { render, staticRenderFns } from "./unused--comp_ProductPageCustomizationInputs-astralito.vue?vue&type=template&id=a294f90e&"
import script from "./unused--comp_ProductPageCustomizationInputs-astralito.vue?vue&type=script&lang=js&"
export * from "./unused--comp_ProductPageCustomizationInputs-astralito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VItem,VItemGroup,VRow})
